import SplitType from 'split-type';
import { gsap } from 'gsap';

import {ScrollTrigger} from 'gsap/ScrollTrigger';
import initScrollTrigger from '../helpers/initScrollTrigger';

import {IS_PHONE} from '../helpers/consts';

export const setSplitText = (el) => {
	return new SplitType(el, { types: 'chars, words'});
};


const DELAY_TIME = 35;

export const splitTitle = (title) => {
	if (!title) return;
	setSplitText(title);

		const chars = title.querySelectorAll('.char');
		chars.forEach((char, i) => {
			char.style.animationDelay = `${i * DELAY_TIME}ms`;
		});

		title.classList.add('is-splitted');
	// if(IS_PHONE) {
	// 	const titles = document.querySelectorAll('.js-slider-screen-group-title');
	// 	titles.forEach(title => {
	// 		setSplitText(title);

	// 		const chars = title.querySelectorAll('.char');
	// 		chars.forEach((char, i) => {
	// 			char.style.animationDelay = `${i * DELAY_TIME}ms`;
	// 		});

	// 		title.classList.add('is-splitted');
	// 	});
	// }
}

export const splitAllTitles = () => {
	const titles = document.querySelectorAll('.js-letter-anim');
	titles.forEach(title => {
		splitTitle(title)
	});

};

const initGroups = () => {
	const groups = document.querySelectorAll('.js-anim-group');

	groups.forEach(group => {
		const title = group.querySelector('.js-letter-anim');
		const chars = title.querySelectorAll('.char');
		chars.forEach((char, i) => {
			char.style.animationDelay = `${i * DELAY_TIME}ms`;
		});
		const text = group.querySelector('.js-anim-group-text');
		text.style.transitionDelay = `${chars.length * DELAY_TIME}ms`;
		ScrollTrigger.create({
			trigger: group,
			start: () => {
				return 'top 80%';
			},
			once: true,
			onEnter: () => {
				group.classList.add('is-animated');
			},
		});
	});
};


export default () => {
	initScrollTrigger();

	initGroups();

};
